export default __webpack_public_path__ + "static/media/logo_pde.c93e1653.svg";